// extracted by mini-css-extract-plugin
export var actions = "_t5-4";
export var item = "_t5-1";
export var price = "_t5-3";
export var quantity = "_t5-2";
export var table = "_t5-0";